module.exports = __webpack_public_path__ + "img/portrait-096.4dea59ca.jpg";